
import { OrdersReplacementApiRemoteService } from '../../Services/api/orders-replacement/orders-replacement-service'
import { IPayloadUpdateOrderReplacement } from '../../Services/api/orders-replacement/orders-replacement.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class UpdateOrdersReplacementUseCase
implements IFormUsecase<IPayloadUpdateOrderReplacement, void> {
  constructor (private readonly OrdersReplacementApi: OrdersReplacementApiRemoteService) {}
    
  public async handle (
    data: IPayloadUpdateOrderReplacement
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.OrdersReplacementApi.update(data)

      if (response.isFailure) {
        return response
      }

    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
